import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchAllData } from '../FirebaseService';

const PortfolioDataContext = createContext(null);

// Fetches bio/experience/education/timeLine/skill/project in ONE Firebase
// read on mount, then hands the result to every component via
// usePortfolioData(). Replaces the old pattern of each section
// (Navbar, Footer, Hero, Skills, Experience, Education, Projects) doing
// its own separate fetch*Data() call.
export const PortfolioDataProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const result = await fetchAllData();
        setData(result);
      } catch (error) {
        setErrorMessage(error.message);
      }
    };

    loadData();
  }, []);

  return (
    <PortfolioDataContext.Provider value={{ data, errorMessage }}>
      {children}
    </PortfolioDataContext.Provider>
  );
};

// Usage in any component:
//   const { data, errorMessage } = usePortfolioData();
//   const bioData = data?.bio;
export const usePortfolioData = () => {
  const context = useContext(PortfolioDataContext);
  if (!context) {
    throw new Error('usePortfolioData must be used within a PortfolioDataProvider');
  }
  return context;
};
